export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to high-speed servers across multiple countries. Access content from anywhere in the world with unlimited bandwidth and lightning-fast connections.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely private and anonymous with our strict no-logs policy.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-teal-600 text-sm font-medium mb-3">// FEATURES</p>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Advanced Security<br />
            Technology
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-5xl text-gray-900 group-hover:text-teal-600 transition-colors`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
